$(document).ready(function(){
    $(".products_list .col-lg-3").slice(0, 10).show();
    $(document.body).on('click', 'a[href="#shwmre"]', function(e){
    e.preventDefault();
     var t = $(this),
       tx = t.text();
      if( tx == 'Load More' ){
       $('.products_list .col-lg-3').show();   
      }
     t.text( (tx == 'Load less') ? 'Load More' : 'Load less').fadeIn();
      if( tx == 'Load less' ){
        $('.products_list .col-lg-3').hide();
        $(".products_list .col-lg-3").slice(0, 10).show();
      }
    });
    $('p.btn_cjds, .lw_subscription p strong').on('click', function(){
        $('html, body').animate({
            scrollTop: $("#step_one").offset().top
        }, 1000); 
    });
    $(document.body).on('click','#select_product', function(){
      var t = $(this);
      t.text('Selected').parent().parent().siblings().find('span').text('Select');
      t.parent().parent().addClass('active').siblings().removeClass('active');
      $('#add-to_carts').trigger('reset');
      product_detail();
      $('.subscription_steps .shrt_content em').hide();
    });
    $('.subscribe_type span').on('click', function(){
      var t = $(this), v = t.data('tid');
      t.addClass('active').siblings().removeClass('active');
      $('#selling_plan').val(v);
      product_detail();
    });
    
    $('[data-slt-opt]').on('click', function(){
      var t = $(this), id = t.data('idd'); box = t.data('pbox');
      var variant = $(box).find('select').val();

        var price = $(box).find('select option:selected').data('price');
      $('[data-id="'+id+'"]').siblings().find('span').text('Select');
      $('[data-id="'+id+'"]').find('span').text('Selected');
      $('[data-id="'+id+'"]').addClass('active').siblings().removeClass('active');
      
       var title = $('.products_list .col-lg-3.active h5').text();
      var thumb = $('.products_list .col-lg-3.active .thumb').html();
      var desc = $('.products_list .col-lg-3.active p.shrt_desc').text();
       
      var id = $('.products_list .col-lg-3.active').data('id');
      var discount = price * 10 /100;
      var total = price-discount;
      if( price >= 80){ 
        $('#ship_free').show();
      }else{
        $('#ship_free').hide();
      }
       
      $('[data-ttprice]').text('$'+total.toFixed(2));
      $('[data-tprice]').html('$'+total.toFixed(2)+'<br/>PER SHIPMENT');
      $('[data-regprice]').text('$'+price);
      $('[data-dprice]').text('-$'+discount.toFixed(2));
      $('.product_detail .thumb').html(thumb);
      $('.product_detail .content h3').html(title+'<small>'+desc+'</small>');
      $('.product_detail .content p.ptype').html($('.subscribe_type span.active').text());
                    
      $('#product-selectors').val(variant);
      $(box).modal('hide');
    });
    function product_detail(){
      var title = $('.products_list .col-lg-3.active h5').text();
      var thumb = $('.products_list .col-lg-3.active .thumb').html();
      var desc = $('.products_list .col-lg-3.active p.shrt_desc').text();
      var price = $('.products_list .col-lg-3.active').data('price');
      var id = $('.products_list .col-lg-3.active').data('id');
      var discount = price * 10 /100;
      var total = price-discount;
      if( price >= 80){
        $('#ship_free').show();
      }else{
        $('#ship_free').hide();
      }
      $('[data-ttprice]').text('$'+total.toFixed(2));
      $('[data-tprice]').html('$'+total.toFixed(2)+'<br/>PER SHIPMENT');
      $('[data-regprice]').text('$'+price);
      $('[data-dprice]').text('-$'+discount.toFixed(2));
      $('#product-selectors').val(id);
      $('.product_detail .thumb').html(thumb);
      $('.product_detail .content h3').html(title+'<small>'+desc+'</small>');
      $('.product_detail .content p.ptype').html($('.subscribe_type span.active').text());
    }
  });